const Demo6Hero = ({ isAuthenticated, onRegister, onDashboard }) => {
    const handleSubmit = (event) => {
        event.preventDefault();
        if (isAuthenticated) {
            onDashboard();
        } else {
            onRegister();
        }
    };

    const ctaLabel = isAuthenticated ? 'Go to Dashboard' : 'Waiting List';

    return (
        <section id="hero-6" className="hero-section bg-snow division">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-lg-6">
                        <div className="hero-6-txt">
                            <h2 className="h2-md">Translate. Collaborate. Deliver.</h2>
                            <p className="p-lg">
                                From upload to delivery, Rush Studio brings your entire translation workflow into one intuitive space. Translate documents, coordinate with your team, and maintain consistency across every language.
                            </p>
                            <form name="quickform" className="quick-form shadow-form" onSubmit={handleSubmit}>
                                <div className="input-group">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control email"
                                        placeholder="Register your interest"
                                        autoComplete="off"
                                        required
                                    />
                                    <span className="input-group-btn form-btn">
                                        <button type="submit" className="btn btn-md btn-stateblue black-hover submit">
                                            {ctaLabel}
                                        </button>
                                    </span>
                                </div>
                                <div className="quick-form-msg">
                                    <span className="loading" />
                                </div>
                            </form>

                            <div className="hero-features-list">
                                <div className="hero-feature-item">
                                    <span className="hero-feature-icon">🌍</span>
                                    <span>100+ Languages Supported</span>
                                </div>
                                <div className="hero-feature-item">
                                    <span className="hero-feature-icon">⚡</span>
                                    <span>AI + Human Translation in One Editor</span>
                                </div>
                                <div className="hero-feature-item">
                                    <span className="hero-feature-icon">👥</span>
                                    <span>Real-Time Team Collaboration</span>
                                </div>
                                <div className="hero-feature-item">
                                    <span className="hero-feature-icon">☁️</span>
                                    <span>Seamless Cloud Integrations (Drive, Dropbox, OneDrive)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="hero-6-img text-center">
                            <img className="img-fluid" src="/images/demo6/Hero Image.png" alt="hero" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="wave-shape-bottom">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 215">
                    <path
                        fill="#ffffff"
                        d="M0,128L120,149.3C240,171,480,213,720,208C960,203,1200,149,1320,122.7L1440,96L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
                    />
                </svg>
            </div>
        </section>
    );
};

export default Demo6Hero;
